// BOOTH DASHBOARD view logic (pure): the opt-in brand theme and which invite the QR points at.
// The default (no ?theme=) look is the original black/slate screen, unchanged.

import { testerInvitePath } from './testerInvite.js';

export type BoothTheme = 'default' | 'anytime-fitness';

export function boothTheme(param: string | null): BoothTheme {
  return param === 'anytime-fitness' ? 'anytime-fitness' : 'default';
}

/** The newest invite that is usable right now. `rows` carry the server's classified state. */
export function pickLiveInviteUrl(
  rows: ReadonlyArray<{ state: string; url: string; createdAt: string }>,
): string | null {
  const live = rows.filter((r) => r.state === 'ok').sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  return live[0]?.url ?? null;
}

/** `?invite=<token>` override: only a well-formed token is honoured (a bad one is ignored). */
export function inviteUrlFromToken(token: string | null, origin: string): string | null {
  if (!token || !/^[A-Za-z0-9]{32}$/.test(token)) return null;
  return `${origin.replace(/\/+$/, '')}${testerInvitePath(token)}`;
}

export function boothInviteUrl(
  override: string | null,
  serverUrl: string | null | undefined,
  origin: string,
): string | null {
  return inviteUrlFromToken(override, origin) ?? serverUrl ?? null;
}
